module.exports = __webpack_public_path__ + "static/media/anatolii-cat-3.840fde2e.jpg";